import React from 'react'
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import copy from 'copy-to-clipboard';

function ColorCard({color}) {

    var copyToClipBoard = (e) =>{
        var id= e.target.id;
        var selectedColor = "#"+(id.split("-")[0]);
        copy(selectedColor);
        toast('Copied', {
            type: "success",
        });
    }
    return (
        <div className="col-md-2">
            <div className="color-body" title="click to copy" id={color.split("#")[1]+"-div"} onClick={copyToClipBoard} style={{"backgroundColor":color}}></div>
            <div><h5 style={{"color":"#173b6c",'textAlign':"center","fontFamily": "sans-serif"}}>{color}</h5></div>
        </div>
    )
}

export default ColorCard
